// frontend/src/contexts/AuthContext.js

import React, { createContext, useCallback, useState, useEffect } from 'react';
import { isAuthenticated, getProfile } from '../services/api'; // Import getProfile to fetch user details

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [authenticated, setAuthenticated] = useState(isAuthenticated());
    const [user, setUser] = useState(null);
    const [permissions, setPermissions] = useState([]);
    const [profileLoading, setProfileLoading] = useState(() => isAuthenticated());

    const fetchUserProfile = useCallback(async () => {
        setProfileLoading(true);
        try {
            const profile = await getProfile();
            setUser(profile.user || null);
            setPermissions(profile.permissions || []); // Set permissions, fallback to empty array if undefined
        } catch (error) {
            console.error('Error fetching user profile:', error);
            setUser(null);
            setPermissions([]);
        } finally {
            setProfileLoading(false);
        }
    }, []);

    useEffect(() => {
        if (authenticated) {
            fetchUserProfile();
        } else {
            setProfileLoading(false);
        }
    }, [authenticated, fetchUserProfile]);

    const login = () => {
        setProfileLoading(true);
        setAuthenticated(true);
    };

    const logout = () => {
        setAuthenticated(false);
        setUser(null);
        setPermissions([]);  // Clear permissions on logout
        setProfileLoading(false);
    };

    return (
        <AuthContext.Provider value={{ authenticated, user, permissions, profileLoading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
